import { useNavigate } from 'react-router-dom'
import { useBasePath } from '../hooks/useBasePath'
import { usePermission } from '../../hooks/usePermission'

export function AccessDeniedPage() {
  const navigate = useNavigate()
  const basePath = useBasePath()
  const { can } = usePermission()

  const homePath = can('view_dashboard')
    ? `${basePath}/dashboard`
    : can('search_products')
      ? `${basePath}/engineer`
      : `${basePath}/no-access`

  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <h2 className="text-2xl font-semibold text-gray-900 mb-2">Access denied</h2>
      <p className="text-sm text-gray-600 mb-6">
        You don't have permission to access this page.
      </p>
      <button
        onClick={() => navigate(homePath)}
        className="inline-block px-4 py-2 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-800"
      >
        Go home
      </button>
    </div>
  )
}
